import { object, string, number, array } from "yup";
import { isHTMLContentEmpty } from "helpers/common";
import { dateRequiredSchema, numberRequiredSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import * as Yup from "yup";

const taskPlanEditSchema = object().shape({
	date: dateRequiredSchema,
	plan_name: stringRequiredSchema,
	no_of_sessions: numberRequiredSchema
		.min(1, "Minimum 1 session is required")
		.max(12, "Maximum 12 sessions allowed"),
	// 3️⃣ Tasks
	tasks: array()
		.of(
			object().shape({
				task_title: string()
					.required("Task title is required"),



				description: string()
					.test(
						"description-required",
						"Description is required",
						(value) => !isHTMLContentEmpty(value)
					),
				strategy: Yup.array().of(
					Yup.object().shape({
						text: Yup.string().required("Strategy is required"),
						attachments: Yup.array().nullable(),
						template_id: Yup.string().nullable(),
						strategyRadio: Yup.string().nullable()
					})
				),

				// attachments: array().of(
				// 	object().shape({
				// 		attachment_key: string().required(),
				// 		attachment_name: string().required(),
				// 	})
				// ),
			})
		)
		.min(1, "At least one task is required")
		.max(4, "Maximum 4 tasks allowed"),
});

export default taskPlanEditSchema;
